export default __webpack_public_path__ + "static/media/oggi2.17dc398c.jpg";